import * as types from '../constants/profile';

let initialState = {
  orders: [],
  isLoading: false,
  filters: {
    active: '1',
    show_my_orders_only: '1',
    search: '',
    start_date: null,
    end_date: null,
  },
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case types.SET_LOADER:
      return {
        ...state,
        isLoading: payload,
      };
    case types.SET_ORDERS:
      return {
        ...state,
        orders: payload,
      };
    case types.SET_FILTERS:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...payload,
        },
      };
    default:
      return state;
  }
};
